import * as React from 'react';
import { Typography } from '@mui/material';

const SectionTitle = ({ label, ...props }) => {
    return (
        <Typography variant="h6" gutterBottom {...props}>
            {label}
        </Typography>
    );
};

export default SectionTitle
